import React from 'react';

import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useStudentGradeStore } from 'store/user/useStudentGradeStore';

const Blank = ({ gradeId, blank, handleModal }) => {
	// Use user's creation store
	const onSelectBlank = useStudentGradeStore(state => state.onSelectBlank);

	// Handle blank addition for student
	const onSelect = () => {
		// Add blank's courses to grade
		onSelectBlank(gradeId, blank.courses);

		// Close blank's modal
		handleModal();
	};

	return (
		<div className="py-3 px-4 border rounded-lg space-x-2 dark:border-neutral-700">
			{/* Blank's information and control */}
			<div className="flex items-center space-x-2">
				<Title
					title={blank.title}
					subtitle={`${blank.courses?.length} moduļi`}
					className="flex-1"
				/>

				<Button
					small
					square
					icon="link"
					to={`/blanks/${blank.id}`}
				/>

				{/* Blank addition if is in modal list */}
				<Button
					small
					square
					icon="add"
					theme="success"
					onClick={onSelect}
				/>
			</div>
		</div>
	);
};

export default Blank;